import { DefenderUploadedDokument } from "interfaces/Application";
import React from "react";
import { Row, Col } from "react-bootstrap";

type FileNameLabelProps = {
  defenderUploadedDokument?: DefenderUploadedDokument;
};

const FileNameLabel: React.VFC<FileNameLabelProps> = ({ defenderUploadedDokument: dud }) => {
  return (
    <>
      {dud?.dateiName && (
        <Row>
          <Col>
            <span>
              Gelieferte Datei: <strong>&apos;{dud.dateiName}&apos;</strong>
            </span>
          </Col>
        </Row>
      )}
    </>
  );
};

export default FileNameLabel;
